import { addMessages } from '@hana/i18n';

// Khoá chuỗi của CRM (Ezy). Mã nghiệp vụ, tên riêng và dữ liệu không dịch.
addMessages('vi', {
  'crm.noWrite': 'Chưa mở ghi ở bản này',
  'crm.notYet': 'Chưa mở ở bản này',
  'crm.ct.csvDone': 'Đã xuất {n} hợp đồng ra CSV',
  'crm.ct.title': 'Hợp đồng dịch vụ',
  'crm.ct.sub': 'HANA (bên A) ↔ khách (bên B)',
  'crm.ct.group': 'Nhóm hợp đồng',
  'crm.ct.tabList': 'Danh sách',
  'crm.ct.tabTpl': 'Mẫu hợp đồng',
  'crm.ct.tabDup': 'Rà trùng',
  'crm.ct.create': 'Tạo hợp đồng',
  'crm.ct.createPlus': '+ Tạo hợp đồng',
  'crm.ct.search': 'Tìm hợp đồng',
  'crm.ct.searchPh': 'Số HĐ / ShortName / MST',
  'crm.ct.quick': 'Lọc nhanh',
  'crm.ct.countOf': '{n} / {total} hợp đồng',
  'crm.ct.count': '{n} hợp đồng',
  'crm.ct.emptyTitle': 'Chưa có hợp đồng nào',
  'crm.ct.errTitle': 'Không tải được hợp đồng',
  'crm.ct.emptyDesc': 'Tạo hợp đồng đầu tiên từ mẫu, hoặc mở danh sách khách có job chưa có hợp đồng.',
  'crm.ct.nocLabel': 'Khách có job chưa có hợp đồng',
  'crm.ct.nocHead': 'Khách có job 12 tháng nhưng chưa có hợp đồng',
  'crm.ct.nocJobs': '{n} job · gần nhất {last}',
  'crm.ct.sale': 'Sale {v}',
  'crm.ct.listLabel': 'Danh sách hợp đồng',
  'crm.ct.noMoney': 'Không có quyền xem số tiền hạn mức.',
  'crm.ct.table': 'Hợp đồng',
  'crm.ct.copyTitle': 'Chép số hợp đồng',
  'crm.ct.copyAria': 'Chép số {code}',
  'crm.ct.copied': 'Đã chép {code}',
  'crm.ct.days': '{n} ngày',
  'crm.ct.bilingual': 'Song ngữ',
  'crm.ct.vi': 'Tiếng Việt',
  'crm.ct.approved': 'Đã duyệt',
  'crm.ct.pending': 'Chờ duyệt',
  'crm.ct.signed': 'Đã ký',
  'crm.ct.unsigned': 'Chưa ký',
  'crm.ct.missing': 'Thiếu: {v}',
  'crm.ct.noMatch': 'Không có hợp đồng khớp bộ lọc.',
  'crm.ct.csv': 'Xuất CSV đang lọc',
  'crm.ct.col.code': 'Số hợp đồng', 'crm.ct.col.cust': 'Khách · MST', 'crm.ct.col.date': 'Ngày HĐ', 'crm.ct.col.exp': 'Hết hạn',
  'crm.ct.col.debt': 'Công nợ', 'crm.ct.col.lang': 'Ngôn ngữ', 'crm.ct.col.appr': 'Duyệt', 'crm.ct.col.sign': 'Ký', 'crm.ct.col.sale': 'Sale',
  'crm.ct.q.all': 'Tất cả', 'crm.ct.q.ap': 'Chờ duyệt', 'crm.ct.q.sg': 'Chưa ký', 'crm.ct.q.e30': 'Sắp hết 30 ngày',
  'crm.ct.q.e60': 'Sắp hết 60 ngày', 'crm.ct.q.miss': 'Thiếu trường', 'crm.ct.q.dup': 'Trùng MST', 'crm.ct.q.noc': 'Có job chưa có HĐ',
  'crm.retry': 'Thử lại',
  'crm.dk.idleNote': 'Số ngày từ job gần nhất · ngưỡng nhắc 30 ngày',
  'crm.dk.openNote': 'Phiếu đang mở · Mới / Chờ giá / Đã báo',
  'crm.dk.lostWhy': 'Lý do Lost',
  'crm.dk.autoDone': 'Vừa tự đổi',
  'crm.dk.private': 'Chỉ mình bạn thấy · không gắn khách',
  'crm.dk.stages': 'Mới / Chờ giá / Đã báo',
  'crm.cu.tab.cus': 'Khách hàng',
  'crm.cu.tab.lead': 'Tiềm năng',
  'crm.cu.tab.partner': 'Đối tác',
  'crm.cu.tab.hq': 'Dữ liệu HQ',
  'crm.cu.col.name': 'Khách hàng · MST',
  'crm.cu.col.sale': 'Sale phụ trách',
  'crm.cu.col.bkg': 'BKG chủ khách',
  'crm.cu.col.jobs': 'Job 90 ngày',
  'crm.cu.col.lim': 'Hạn mức · còn lại',
  'crm.cu.col.od': 'Quá hạn',
  'crm.cu.col.my': 'myHANA',
  'crm.cu.col.upd': 'Cập nhật',
  'crm.cu.status.wait': 'Chờ duyệt',
  'crm.cu.status.inact': 'Ngưng dùng',
  'crm.cu.status.bl': 'Blacklist',
  'crm.cu.status.ap': 'Đã duyệt',
  'crm.cu.contract.sign': 'HĐ đã ký',
  'crm.cu.contract.unsigned': 'HĐ chưa ký',
  'crm.cu.contract.exp': 'HĐ sắp hết hạn',
  'crm.cu.contract.none': 'Chưa có HĐ',
  'crm.cu.lim.prepaid': 'Trả trước',
  'crm.cu.lim.over': 'Vượt hạn mức',
  'crm.cu.lim.within': 'Trong hạn mức',
  'crm.cu.tabLater': 'Tab này chưa mở ở bản này',
  'crm.cu.title': 'Khách hàng',
  'crm.cu.group': 'Nhóm danh bạ',
  'crm.cu.add': 'Thêm khách',
  'crm.cu.search': 'Tìm khách hàng',
  'crm.cu.searchPh': 'Tên khách / MST / người liên hệ',
  'crm.cu.hanaTitle': 'Lọc bằng câu hỏi cho Hana',
  'crm.cu.hanaLater': 'Hỏi Hana chưa mở ở bản này',
  'crm.cu.hana': 'Hỏi Hana',
  'crm.cu.filterLater': 'Bộ lọc chưa mở ở bản này',
  'crm.cu.filter': 'Lọc',
  'crm.cu.shown': 'Số khách đang hiện',
  'crm.cu.count': '{n} khách',
  'crm.cu.attention': 'Khách quá hạn hoặc vượt hạn mức',
  'crm.cu.noMatch': 'Không có khách khớp',
  'crm.cu.empty': 'Chưa có khách hàng',
  'crm.cu.noMatchDesc': 'Thử đổi từ khoá tìm.',
  'crm.cu.list': 'Danh sách khách hàng',
  'crm.cu.hidden': 'Số tiền ẩn',
  'crm.cu.selectAll': 'Chọn tất cả',
  'crm.cu.select': 'Chọn {id}',
  'crm.cu.copySn': 'Chép ShortName',
  'crm.cu.copySnAria': 'Chép ShortName {id}',
  'crm.cu.copied': 'Đã chép ShortName {id}',
  'crm.cu.call': 'Gọi liên hệ chính',
  'crm.cu.callAria': 'Gọi liên hệ chính của {id}',
  'crm.cu.saleOf': 'Sale {v}',
  'crm.cu.bkgOf': 'BKG chủ khách {v}',
  'crm.cu.bkg2Of': 'BKG backup {v}',
  'crm.cu.limit': 'Hạn mức',
  'crm.cu.debt': 'Công nợ',
  'crm.cu.overdue': 'Quá hạn',
  'crm.cu.holdDo': 'Giữ DO',
  'crm.cu.updatedBy': 'Cập nhật {d} · {u}',
  'crm.cu.countOf': '{n} / {total} khách',
  'crm.cu.prev': 'Trang trước',
  'crm.cu.next': 'Trang sau',
  'crm.st.openLater': 'Mở {v} chưa mở ở bản này',
  'crm.st.byCust': 'Việc theo khách',
  'crm.st.title': 'Hôm nay',
  'crm.st.date': 'Thứ Năm 22/Oct/2026',
  'crm.st.scope': 'Phạm vi',
  'crm.st.mine': 'Của tôi',
  'crm.st.team': 'Cả nhóm',
  'crm.st.period': 'Kỳ theo dõi',
  'crm.st.days': '{n} ngày',
  'crm.st.noti': 'Thông báo',
  'crm.st.openDock': 'Mở cột phải',
  'crm.st.more': 'Thao tác khác',
  'crm.st.add': 'Thêm việc',
  'crm.st.emptyTitle': 'Hôm nay chưa có việc',
  'crm.st.errTitle': 'Không tải được việc hôm nay',
  'crm.st.emptyDesc': 'Hôm nay chưa có việc.',
  'crm.st.errDesc': 'Mất kết nối tới máy chủ lúc 22:30. Thử lại sau ít phút.',
  'crm.st.onlyMine': 'Chỉ xem việc của bạn.',
  'crm.st.kpi': 'Đếm việc',
  'crm.st.pace': 'Nhịp việc',
  'crm.st.byDue': 'Việc theo hạn',
  'crm.st.doneIn': 'Đã xong trong kỳ',
  'crm.st.ofTasks': '{done}/{all} việc',
  'crm.st.doneAria': 'Đã xong {done} trên {all} việc',
  'crm.st.teamTasks': 'Việc cả nhóm',
  'crm.st.teamHint': 'bấm tên để xem việc của từng người',
  'crm.st.tmLine': '{open} việc · {n} khách',
  'crm.st.tmAria': '{k}: {open} việc, {od} quá hạn',
  'crm.st.overdueN': '{n} quá hạn',
  'crm.st.listCount': '{c} khách · {n} việc chưa xong',
  'crm.st.clear': 'Bỏ lọc',
  'crm.st.none': 'Không còn việc nào khớp. Mọi follow đã xong.',
  'crm.st.tasksOf': 'Việc của {v}',
  'crm.st.contact': 'Liên hệ {v}',
  'crm.st.nTasks': '{n} việc',
  'crm.st.callAria': 'Gọi {v}',
  'crm.st.calling': 'Đang gọi {v}',
  'crm.st.log': 'Ghi tương tác',
  'crm.st.doneTask': 'Xong: {v}',
  'crm.iq.tabOv': 'Tổng quan',
  'crm.iq.tabMail': 'Mail',
  'crm.iq.tabTask': 'Việc',
  'crm.iq.tabHist': 'Lịch sử',
  'crm.iq.back': 'Quay lại danh sách cơ hội',
  'crm.iq.title': 'Cơ hội',
  'crm.iq.stageLbl': 'Giai đoạn phiếu',
  'crm.iq.svc': 'Dịch vụ',
  'crm.iq.custOf': 'Khách {v}',
  'crm.iq.followDate': 'Ngày follow',
  'crm.iq.today': 'Hôm nay',
  'crm.iq.saleOf': 'Sale {v}',
  'crm.iq.more': 'Thao tác khác',
  'crm.iq.save': 'Lưu thay đổi',
  'crm.iq.tabsLbl': 'Nhóm thông tin phiếu',
  'crm.iq.bannerMsg': 'Mở phiếu {id} từ việc follow SLD ở Việc & Duyệt',
  'crm.iq.reopen': 'Mở lại phiếu',
  'crm.iq.toTasks': 'Về Việc & Duyệt',
  'crm.iq.closeNote': 'Đóng thông báo',
  'crm.iq.nfTitle': 'Không tìm thấy phiếu',
  'crm.iq.nfDesc': 'Phiếu đã xoá hoặc không còn trong danh sách.',
  'crm.iq.toList': 'Về danh sách',
  'crm.iq.cStage': 'Giai đoạn',
  'crm.iq.hStage': 'Mới → Chờ giá → Đã báo → Won / Lost. Won hỏi JobID, Lost hỏi lý do.',
  'crm.iq.cInfo': 'Thông tin phiếu',
  'crm.iq.hInfo': 'Khách, Sale, dịch vụ, chủ đề, ngày follow (tạo / dời việc ở Việc & Duyệt).',
  'crm.iq.fCust': 'Khách',
  'crm.iq.fSale': 'Sale phụ trách',
  'crm.iq.fSubject': 'Chủ đề',
  'crm.iq.cQuote': 'Báo giá gắn phiếu',
  'crm.iq.hQuote': 'Gửi mail báo giá từ Báo giá tự gắn và chuyển Đã báo.',
  'crm.iq.attach': 'Gắn báo giá',
  'crm.iq.sendQuote': 'Gửi mail báo giá',
  'crm.iq.sentCust': 'gửi khách · Sent',
  'crm.iq.noQuote': 'Chưa gắn báo giá.',
  'crm.iq.cPrice': 'Giá dịch vụ riêng và job gần đây',
  'crm.iq.hPrice': 'Bảng giá dịch vụ riêng đã gửi và job gần đây của khách (đếm job, không tiền).',
  'crm.iq.priceSent': 'Bảng giá dịch vụ riêng · đã gửi',
  'crm.iq.recentJobs': 'Job gần đây của khách',
  'crm.iq.cMail': 'Mail của phiếu',
  'crm.iq.hMail': 'Hộp chung lọc theo nhãn KH:<khách>; hộp cá nhân lọc theo email liên hệ của khách.',
  'crm.iq.srcMail': 'Mail gốc',
  'crm.iq.open': 'Mở',
  'crm.iq.cTask': 'Việc của phiếu',
  'crm.iq.hTask': 'Hạn tính theo lịch làm việc công ty · hiện ở Việc & Duyệt.',
  'crm.iq.doneOf': 'Xong {v}',
  'crm.iq.noTask': 'Chưa có việc.',
  'crm.iq.hHist': 'Nhật ký phiếu (hệ thống tự đổi giai đoạn + thao tác của Sale).',
  'crm.iq.aside': 'Cột phải cơ hội',
  'crm.iq.cTodo': 'Việc cần làm',
  'crm.iq.hTodo': 'Việc của phiếu chưa xong (follow tự sinh + thêm tay) và bước Pricing đang chờ.',
  'crm.iq.noTodo': 'Không còn việc.',
  'crm.iq.cRfq': 'Hỏi giá',
  'crm.iq.hRfq': 'Hỏi Pricing nội bộ và hỏi giá nhà cung cấp cho phiếu này.',
  'crm.iq.askPricingH': 'Hỏi Pricing nội bộ',
  'crm.iq.askPricing': 'Hỏi Pricing',
  'crm.iq.ackPrice': 'Xác nhận đã nhận giá',
  'crm.iq.askSupH': 'Hỏi giá nhà cung cấp',
  'crm.iq.openPartnerRfq': 'Mở hỏi giá đối tác',
  'crm.iq.cMain': 'Thông tin chính',
  'crm.iq.hMain': 'Tóm tắt phiếu.',
  'crm.iq.cWho': 'Người phụ trách',
  'crm.iq.hWho': 'Sale phụ trách phiếu và người duyệt.',
  'crm.iq.mgr': '[SAL-MGR] · trưởng kinh doanh',
  'crm.iq.cLink': 'Liên kết',
  'crm.iq.hLink': 'Mở nhanh các màn liên quan.',
  'crm.iq.p360': 'Hồ sơ khách 360 {v}',
  'crm.iq.lQuote': 'Báo giá',
  'crm.iq.lPartnerRfq': 'Hỏi giá đối tác',
  'crm.iq.lTasks': 'Việc & Duyệt',
  'crm.iq.noFollow': 'Không follow',
  'crm.pc.funnel': 'Phễu cơ hội',
  'crm.pc.winRate': 'tỷ lệ chốt',
  'crm.pc.won': 'Chốt Won',
  'crm.pc.lost': 'Chốt Lost',
  'crm.pc.back': 'Lùi về {v}',
  'crm.pb.drafts': 'Hana đề xuất từ mail / Zalo',
  'crm.pb.loose': 'Báo giá & hỏi giá chưa gắn phiếu',
  'crm.stc.notes': 'Sổ tay',
  'crm.cp.open360': 'Mở 360',
  'crm.cp.contact': 'Liên hệ',
  'crm.cp.noContact': 'Chưa có liên hệ nào.',
  'crm.cp.noTask': 'Không có việc.',
  'crm.pd.mst': 'MST {v}',
  'crm.pd.jobMonth': 'Job dùng {id} theo tháng: {v}',
  'crm.pd.nJob': '{m}: {n} job',
  'crm.pd.contacts': 'Liên hệ · {n}',
  'crm.pd.edit': 'Sửa {n}',
  'crm.pd.del': 'Xoá {n}',
  'crm.pd.banks': 'Tài khoản nhận tiền · {n}',
  'crm.pd.pause': 'Ngưng dùng tài khoản {n}',
  'crm.pd.hidePw': 'Ẩn mật khẩu {k}',
  'crm.pd.showPw': 'Hiện mật khẩu {k}',
  'crm.pd.hide': 'Ẩn',
  'crm.pd.show': 'Hiện',
  'crm.pd.editNote': 'Sửa ghi chú {n}',
  'crm.pd.delNote': 'Xoá ghi chú {n}',
  'crm.pd.view': 'Xem {n}',
  'crm.pd.noViewer': 'Trình xem tệp chưa mở ở bản này',
  'crm.pd.viewBtn': 'Xem',
});

addMessages('en', {
  'crm.noWrite': 'Write is not enabled in this version',
  'crm.notYet': 'Not available in this version',
  'crm.ct.csvDone': 'Exported {n} contracts to CSV',
  'crm.ct.title': 'Service contracts',
  'crm.ct.sub': 'HANA (party A) ↔ customer (party B)',
  'crm.ct.group': 'Contract groups',
  'crm.ct.tabList': 'List',
  'crm.ct.tabTpl': 'Contract templates',
  'crm.ct.tabDup': 'Duplicate check',
  'crm.ct.create': 'New contract',
  'crm.ct.createPlus': '+ New contract',
  'crm.ct.search': 'Search contracts',
  'crm.ct.searchPh': 'Contract no. / ShortName / Tax ID',
  'crm.ct.quick': 'Quick filter',
  'crm.ct.countOf': '{n} / {total} contracts',
  'crm.ct.count': '{n} contracts',
  'crm.ct.emptyTitle': 'No contracts yet',
  'crm.ct.errTitle': 'Could not load contracts',
  'crm.ct.emptyDesc': 'Create the first contract from a template, or open customers with jobs but no contract.',
  'crm.ct.nocLabel': 'Customers with jobs but no contract',
  'crm.ct.nocHead': 'Customers with jobs in the last 12 months but no contract',
  'crm.ct.nocJobs': '{n} jobs · latest {last}',
  'crm.ct.sale': 'Sale {v}',
  'crm.ct.listLabel': 'Contract list',
  'crm.ct.noMoney': 'You do not have permission to view credit limits.',
  'crm.ct.table': 'Contracts',
  'crm.ct.copyTitle': 'Copy contract number',
  'crm.ct.copyAria': 'Copy number {code}',
  'crm.ct.copied': 'Copied {code}',
  'crm.ct.days': '{n} days',
  'crm.ct.bilingual': 'Bilingual',
  'crm.ct.vi': 'Vietnamese',
  'crm.ct.approved': 'Approved',
  'crm.ct.pending': 'Pending approval',
  'crm.ct.signed': 'Signed',
  'crm.ct.unsigned': 'Unsigned',
  'crm.ct.missing': 'Missing: {v}',
  'crm.ct.noMatch': 'No contracts match the filter.',
  'crm.ct.csv': 'Export filtered CSV',
  'crm.ct.col.code': 'Contract no.', 'crm.ct.col.cust': 'Customer · Tax ID', 'crm.ct.col.date': 'Contract date', 'crm.ct.col.exp': 'Expires',
  'crm.ct.col.debt': 'Receivable', 'crm.ct.col.lang': 'Language', 'crm.ct.col.appr': 'Approval', 'crm.ct.col.sign': 'Signed', 'crm.ct.col.sale': 'Sale',
  'crm.ct.q.all': 'All', 'crm.ct.q.ap': 'Pending approval', 'crm.ct.q.sg': 'Unsigned', 'crm.ct.q.e30': 'Expiring in 30 days',
  'crm.ct.q.e60': 'Expiring in 60 days', 'crm.ct.q.miss': 'Missing fields', 'crm.ct.q.dup': 'Duplicate Tax ID', 'crm.ct.q.noc': 'Jobs without contract',
  'crm.retry': 'Retry',
  'crm.dk.idleNote': 'Days since last job · reminder threshold 30 days',
  'crm.dk.openNote': 'Open tickets · New / Pricing / Quoted',
  'crm.dk.lostWhy': 'Lost reason',
  'crm.dk.autoDone': 'Just auto-updated',
  'crm.dk.private': 'Only you can see this · not linked to a customer',
  'crm.dk.stages': 'New / Pricing / Quoted',
  'crm.cu.tab.cus': 'Customers',
  'crm.cu.tab.lead': 'Leads',
  'crm.cu.tab.partner': 'Partners',
  'crm.cu.tab.hq': 'HQ data',
  'crm.cu.col.name': 'Customer · Tax ID',
  'crm.cu.col.sale': 'Sales owner',
  'crm.cu.col.bkg': 'Main booking staff',
  'crm.cu.col.jobs': 'Jobs (90 days)',
  'crm.cu.col.lim': 'Credit limit · remaining',
  'crm.cu.col.od': 'Overdue',
  'crm.cu.col.my': 'myHANA',
  'crm.cu.col.upd': 'Updated',
  'crm.cu.status.wait': 'Pending approval',
  'crm.cu.status.inact': 'Inactive',
  'crm.cu.status.bl': 'Blacklist',
  'crm.cu.status.ap': 'Approved',
  'crm.cu.contract.sign': 'Contract signed',
  'crm.cu.contract.unsigned': 'Contract unsigned',
  'crm.cu.contract.exp': 'Contract expiring',
  'crm.cu.contract.none': 'No contract',
  'crm.cu.lim.prepaid': 'Prepaid',
  'crm.cu.lim.over': 'Over limit',
  'crm.cu.lim.within': 'Within limit',
  'crm.cu.tabLater': 'This tab is not available in this version',
  'crm.cu.title': 'Customers',
  'crm.cu.group': 'Directory groups',
  'crm.cu.add': 'Add customer',
  'crm.cu.search': 'Search customers',
  'crm.cu.searchPh': 'Customer / Tax ID / contact',
  'crm.cu.hanaTitle': 'Filter by asking Hana',
  'crm.cu.hanaLater': 'Ask Hana is not available in this version',
  'crm.cu.hana': 'Ask Hana',
  'crm.cu.filterLater': 'Filters are not available in this version',
  'crm.cu.filter': 'Filter',
  'crm.cu.shown': 'Customers shown',
  'crm.cu.count': '{n} customers',
  'crm.cu.attention': 'Customers overdue or over limit',
  'crm.cu.noMatch': 'No matching customers',
  'crm.cu.empty': 'No customers yet',
  'crm.cu.noMatchDesc': 'Try a different search term.',
  'crm.cu.list': 'Customer list',
  'crm.cu.hidden': 'Amounts hidden',
  'crm.cu.selectAll': 'Select all',
  'crm.cu.select': 'Select {id}',
  'crm.cu.copySn': 'Copy ShortName',
  'crm.cu.copySnAria': 'Copy ShortName {id}',
  'crm.cu.copied': 'Copied ShortName {id}',
  'crm.cu.call': 'Call main contact',
  'crm.cu.callAria': 'Call main contact of {id}',
  'crm.cu.saleOf': 'Sale {v}',
  'crm.cu.bkgOf': 'Main booking staff {v}',
  'crm.cu.bkg2Of': 'Backup booking staff {v}',
  'crm.cu.limit': 'Credit limit',
  'crm.cu.debt': 'Receivable',
  'crm.cu.overdue': 'Overdue',
  'crm.cu.holdDo': 'DO hold',
  'crm.cu.updatedBy': 'Updated {d} · {u}',
  'crm.cu.countOf': '{n} / {total} customers',
  'crm.cu.prev': 'Previous page',
  'crm.cu.next': 'Next page',
  'crm.st.openLater': 'Opening {v} is not available in this version',
  'crm.st.byCust': 'Tasks by customer',
  'crm.st.title': 'Today',
  'crm.st.date': 'Thursday 22/Oct/2026',
  'crm.st.scope': 'Scope',
  'crm.st.mine': 'Mine',
  'crm.st.team': 'Whole team',
  'crm.st.period': 'Tracking period',
  'crm.st.days': '{n} days',
  'crm.st.noti': 'Notifications',
  'crm.st.openDock': 'Open right panel',
  'crm.st.more': 'More actions',
  'crm.st.add': 'Add task',
  'crm.st.emptyTitle': 'No tasks today',
  'crm.st.errTitle': 'Could not load today’s tasks',
  'crm.st.emptyDesc': 'No tasks today.',
  'crm.st.errDesc': 'Lost connection to the server at 22:30. Try again in a few minutes.',
  'crm.st.onlyMine': 'You can only see your own tasks.',
  'crm.st.kpi': 'Task counts',
  'crm.st.pace': 'Task pace',
  'crm.st.byDue': 'Tasks by due date',
  'crm.st.doneIn': 'Done in period',
  'crm.st.ofTasks': '{done}/{all} tasks',
  'crm.st.doneAria': 'Done {done} of {all} tasks',
  'crm.st.teamTasks': 'Team tasks',
  'crm.st.teamHint': 'click a name to see that person’s tasks',
  'crm.st.tmLine': '{open} tasks · {n} customers',
  'crm.st.tmAria': '{k}: {open} tasks, {od} overdue',
  'crm.st.overdueN': '{n} overdue',
  'crm.st.listCount': '{c} customers · {n} tasks open',
  'crm.st.clear': 'Clear filter',
  'crm.st.none': 'No matching tasks. All follow-ups are done.',
  'crm.st.tasksOf': 'Tasks of {v}',
  'crm.st.contact': 'Contact {v}',
  'crm.st.nTasks': '{n} tasks',
  'crm.st.callAria': 'Call {v}',
  'crm.st.calling': 'Calling {v}',
  'crm.st.log': 'Log interaction',
  'crm.st.doneTask': 'Done: {v}',
  'crm.iq.tabOv': 'Overview',
  'crm.iq.tabMail': 'Mail',
  'crm.iq.tabTask': 'Tasks',
  'crm.iq.tabHist': 'History',
  'crm.iq.back': 'Back to opportunity list',
  'crm.iq.title': 'Opportunity',
  'crm.iq.stageLbl': 'Ticket stage',
  'crm.iq.svc': 'Services',
  'crm.iq.custOf': 'Customer {v}',
  'crm.iq.followDate': 'Follow date',
  'crm.iq.today': 'Today',
  'crm.iq.saleOf': 'Sales {v}',
  'crm.iq.more': 'More actions',
  'crm.iq.save': 'Save changes',
  'crm.iq.tabsLbl': 'Ticket info groups',
  'crm.iq.bannerMsg': 'Opened ticket {id} from the SLD follow task in Tasks & Approvals',
  'crm.iq.reopen': 'Reopen ticket',
  'crm.iq.toTasks': 'Back to Tasks & Approvals',
  'crm.iq.closeNote': 'Dismiss notice',
  'crm.iq.nfTitle': 'Ticket not found',
  'crm.iq.nfDesc': 'The ticket was deleted or is no longer in the list.',
  'crm.iq.toList': 'Back to list',
  'crm.iq.cStage': 'Stage',
  'crm.iq.hStage': 'New → Awaiting price → Quoted → Won / Lost. Won asks for JobID, Lost asks for a reason.',
  'crm.iq.cInfo': 'Ticket info',
  'crm.iq.hInfo': 'Customer, Sales, services, subject, follow date (create / move tasks in Tasks & Approvals).',
  'crm.iq.fCust': 'Customer',
  'crm.iq.fSale': 'Sales owner',
  'crm.iq.fSubject': 'Subject',
  'crm.iq.cQuote': 'Quotes on ticket',
  'crm.iq.hQuote': 'Sending a quote mail from Quotes attaches it and moves the ticket to Quoted.',
  'crm.iq.attach': 'Attach quote',
  'crm.iq.sendQuote': 'Send quote mail',
  'crm.iq.sentCust': 'sent to customer · Sent',
  'crm.iq.noQuote': 'No quote attached.',
  'crm.iq.cPrice': 'Custom service rates and recent jobs',
  'crm.iq.hPrice': 'Custom service rate sheets sent and the customer’s recent jobs (job count, no money).',
  'crm.iq.priceSent': 'Custom service rates · sent',
  'crm.iq.recentJobs': 'Customer’s recent jobs',
  'crm.iq.cMail': 'Ticket mail',
  'crm.iq.hMail': 'Shared inbox filters by label KH:<customer>; personal inbox filters by the customer’s contact email.',
  'crm.iq.srcMail': 'Original mail',
  'crm.iq.open': 'Open',
  'crm.iq.cTask': 'Ticket tasks',
  'crm.iq.hTask': 'Due dates follow the company work calendar · shown in Tasks & Approvals.',
  'crm.iq.doneOf': 'Done {v}',
  'crm.iq.noTask': 'No tasks yet.',
  'crm.iq.hHist': 'Ticket log (automatic stage changes + Sales actions).',
  'crm.iq.aside': 'Opportunity side column',
  'crm.iq.cTodo': 'To do',
  'crm.iq.hTodo': 'Open ticket tasks (auto follow + manual) and the pending Pricing step.',
  'crm.iq.noTodo': 'Nothing left to do.',
  'crm.iq.cRfq': 'Ask for price',
  'crm.iq.hRfq': 'Ask internal Pricing and ask suppliers for a price for this ticket.',
  'crm.iq.askPricingH': 'Ask internal Pricing',
  'crm.iq.askPricing': 'Ask Pricing',
  'crm.iq.ackPrice': 'Confirm price received',
  'crm.iq.askSupH': 'Ask suppliers for a price',
  'crm.iq.openPartnerRfq': 'Open partner price request',
  'crm.iq.cMain': 'Key info',
  'crm.iq.hMain': 'Ticket summary.',
  'crm.iq.cWho': 'Owners',
  'crm.iq.hWho': 'Sales owner and approver of the ticket.',
  'crm.iq.mgr': '[SAL-MGR] · head of sales',
  'crm.iq.cLink': 'Links',
  'crm.iq.hLink': 'Quick links to related screens.',
  'crm.iq.p360': 'Customer 360 profile {v}',
  'crm.iq.lQuote': 'Quotes',
  'crm.iq.lPartnerRfq': 'Partner price requests',
  'crm.iq.lTasks': 'Tasks & Approvals',
  'crm.iq.noFollow': 'No follow',
  'crm.pc.funnel': 'Opportunity funnel',
  'crm.pc.winRate': 'win rate',
  'crm.pc.won': 'Mark Won',
  'crm.pc.lost': 'Mark Lost',
  'crm.pc.back': 'Move back to {v}',
  'crm.pb.drafts': 'Hana suggestions from mail / Zalo',
  'crm.pb.loose': 'Quotes & inquiries not linked to a deal',
  'crm.stc.notes': 'Notebook',
  'crm.cp.open360': 'Open 360',
  'crm.cp.contact': 'Contact',
  'crm.cp.noContact': 'No contacts yet.',
  'crm.cp.noTask': 'No tasks.',
});

addMessages('vi', {
  'crm.cdt.chuaCoLienHe': 'Chưa có liên hệ nào.',
  'crm.cdt.hoTenDienThoai': 'Họ tên · điện thoại · email',
  'crm.cdt.chuSoHuu': '· chủ sở hữu',
  'crm.cdt.goi': 'Gọi',
  'crm.cdt.chuaCoHopDong': 'Chưa có hợp đồng.',
  'crm.cdt.mocJob': 'Mốc job',
  'crm.cdt.bat': 'Bật',
  'crm.cdt.baoCho': 'Báo cho',
  'crm.cdt.mau': 'Mẫu',
  'crm.cdt.chuaCoLienHe2': 'Chưa có liên hệ kế toán có Zalo',
  'crm.cdt.chuaCoTaiKhoan': 'Chưa có tài khoản nhận hoàn tiền.',
  'crm.cdt.datMacDinh': 'Đặt mặc định',
  'crm.cdt.xacMinh': 'Xác minh',
  'crm.cdt.ngungDung': 'Ngưng dùng',
  'crm.cdt.suaCauHinh': 'Sửa cấu hình',
  'crm.cdt.freeTimeDemDet': 'Free time DEM / DET riêng (ngày)',
  'crm.cdt.hangLoaiCont': 'Hãng · loại cont',
  'crm.cdt.chuanHang': 'Chuẩn hãng',
  'crm.cdt.maPhiChiHo': 'Mã phí chi hộ / xuất lại',
  'crm.cdt.chuaCoTuongTac': 'Chưa có tương tác ở nhóm này.',
  'crm.cdt.khongCoHoaDon': 'Không có hoá đơn chưa thu.',
  'crm.cdt.chuaCoTaiKhoan2': 'Chưa có tài khoản nào.',
  'crm.cdt.chuaCoGhiChu': 'Chưa có ghi chú. Ghi các lưu ý khi làm hàng cho đối tác này.',
  'crm.cdt.chuaCoTepNao': 'Chưa có tệp nào.',
  'crm.cdt.jobTruocNgayChuyen': 'Job trước ngày chuyển / chia vẫn giữ Sale cũ',
  'crm.cdt.khongCoJobO': 'Không có job ở nhóm này.',
  'crm.cdt.tuyen': 'Tuyến',
  'crm.cdt.trangThai': 'Trạng thái',
  'crm.cdt.doBangSoDong': '· đo bằng số dòng / job',
  'crm.cdt.soTienAn': 'Số tiền ẩn ••••',
  'crm.cdt.duyetAccCaKe': 'Duyệt: [ACC-CA · Kế toán trưởng] · PAYMENT-APPROVE · Ghế trống · leo lên BOD-DIR PHILIP',
  'crm.cdt.gomRfdDoAcc': 'Gom RFD do [ACC-CP · Kế toán chi phí] làm',
  'crm.cdt.khongCoCanhBao': 'Không có cảnh báo.',
  'crm.cdt.accCaKeToan': '[ACC-CA · Kế toán trưởng] · PAYMENT-APPROVE',
  'crm.cdt.gheTrongLeoLen': 'Ghế trống · leo lên BOD-DIR PHILIP',
  'crm.cdt.chuaCoNguoiNhan': 'Chưa có người nhận.',
  'crm.cdt.dongChuaChiTao': 'dòng chưa chi · Tạo RFD tự tách mỗi người nhận một phiếu',
  'crm.cdt.tuyenHangChinh': 'Tuyến · hãng chính',
  'crm.cdt.tyTrongJob': 'Tỷ trọng job',
  'crm.cdt.chuaCoToKhai': 'Chưa có tờ khai theo MST này.',
  'crm.cdt.nghinUsdLoSo': 'nghìn USD · lô · so cùng kỳ',
  'crm.cdt.goiYKhaiThue': 'Gợi ý khai thuê',
  'crm.cdt.taoCoHoiBan': 'Tạo cơ hội bán hàng',
  'crm.cdt.khachDangHopTac': 'Khách đang hợp tác',
  'crm.cdt.giuDoVuotHan': 'Giữ DO · vượt hạn mức',
  'crm.cdt.thuLai': 'Thử lại',
  'crm.cdt.veDanhSach': 'Về danh sách',
  'crm.cdt.khachChuaCoJob': 'Khách chưa có job. Bấm “+ Tạo job” hoặc gửi báo giá trước.',
  'crm.cdt.chuaGhiTuongTac': 'Chưa ghi tương tác nào.',
  'crm.cdt.khongCoViec': 'Không có việc.',
  'crm.cdt.6Thang': '6 tháng',
  'crm.cdt.chuaDungTrongJob': 'Chưa dùng trong job nào 90 ngày qua.',
  'crm.cdt.khongConViecNao': 'Không còn việc nào cho hồ sơ này.',
  'crm.cdt.ganLoai': 'Gắn loại',
  'crm.cdt.themLienHe': 'Thêm liên hệ',
  'crm.cdt.chuaCoLienHe3': 'Chưa có liên hệ. Thêm người nhận lệnh / thanh toán trước khi dùng đối tác trên job.',
  'crm.cdt.themTaiKhoan': 'Thêm tài khoản',
  'crm.cdt.chuaCoTaiKhoan3': 'Chưa có tài khoản. Thêm và tra VietQR để khớp chủ tài khoản trước khi lập đề nghị thanh toán.',
  'crm.cdt.xemVaSuaO': 'Xem và sửa ở Thiết lập giá ›',
  'crm.cdt.localChargeChiAp': 'Local charge chỉ áp dụng cho đối tác loại CARRIER / COLOADER.',
  'crm.cdt.chuaLuuTaiKhoan': 'Chưa lưu tài khoản cổng nào.',
  'crm.cdt.ghiChu': 'Ghi chú',
  'crm.cdt.sua': 'Sửa',
  'crm.cdt.xoa': 'Xoá',
  'crm.cdt.taiTep': 'Tải tệp',
  'crm.cdt.cachTinhHanTra': 'Cách tính hạn trả',
  'crm.cdt.soNgaySauHoa': 'Số ngày sau hoá đơn',
  'crm.cdt.ngayChotTrongThang': 'Ngày chốt trong tháng',
  'crm.cdt.soNgayTinhTu': 'Số ngày tính từ ETA / ETD',
  'crm.cdt.luuDieuKhoan': 'Lưu điều khoản',
});

addMessages('en', {
  'crm.cdt.chuaCoLienHe': 'No contacts yet.',
  'crm.cdt.hoTenDienThoai': 'Name · phone · email',
  'crm.cdt.chuSoHuu': '· owner',
  'crm.cdt.goi': 'Call',
  'crm.cdt.chuaCoHopDong': 'No contracts yet.',
  'crm.cdt.mocJob': 'Job milestone',
  'crm.cdt.bat': 'On',
  'crm.cdt.baoCho': 'Notify',
  'crm.cdt.mau': 'Template',
  'crm.cdt.chuaCoLienHe2': 'No accounting contact with Zalo',
  'crm.cdt.chuaCoTaiKhoan': 'No refund receiving account yet.',
  'crm.cdt.datMacDinh': 'Set as default',
  'crm.cdt.xacMinh': 'Verify',
  'crm.cdt.ngungDung': 'Stop using',
  'crm.cdt.suaCauHinh': 'Edit settings',
  'crm.cdt.freeTimeDemDet': 'Custom DEM / DET free time (days)',
  'crm.cdt.hangLoaiCont': 'Carrier · container type',
  'crm.cdt.chuanHang': 'Carrier standard',
  'crm.cdt.maPhiChiHo': 'Pass-through / re-invoice charge codes',
  'crm.cdt.chuaCoTuongTac': 'No interactions in this group.',
  'crm.cdt.khongCoHoaDon': 'No unpaid invoices.',
  'crm.cdt.chuaCoTaiKhoan2': 'No accounts yet.',
  'crm.cdt.chuaCoGhiChu': 'No notes yet. Record handling tips for this partner.',
  'crm.cdt.chuaCoTepNao': 'No files yet.',
  'crm.cdt.jobTruocNgayChuyen': 'Jobs before the transfer / split date keep the previous Sale',
  'crm.cdt.khongCoJobO': 'No jobs in this group.',
  'crm.cdt.tuyen': 'Route',
  'crm.cdt.trangThai': 'Status',
  'crm.cdt.doBangSoDong': '· measured in lines / jobs',
  'crm.cdt.soTienAn': 'Amount hidden ••••',
  'crm.cdt.duyetAccCaKe': 'Approval: [ACC-CA · Chief Accountant] · PAYMENT-APPROVE · Seat vacant · escalates to BOD-DIR PHILIP',
  'crm.cdt.gomRfdDoAcc': 'RFD batching done by [ACC-CP · Cost Accountant]',
  'crm.cdt.khongCoCanhBao': 'No alerts.',
  'crm.cdt.accCaKeToan': '[ACC-CA · Chief Accountant] · PAYMENT-APPROVE',
  'crm.cdt.gheTrongLeoLen': 'Seat vacant · escalates to BOD-DIR PHILIP',
  'crm.cdt.chuaCoNguoiNhan': 'No recipients yet.',
  'crm.cdt.dongChuaChiTao': 'unpaid lines · Creating RFD splits one slip per recipient',
  'crm.cdt.tuyenHangChinh': 'Route · main carrier',
  'crm.cdt.tyTrongJob': 'Job share',
  'crm.cdt.chuaCoToKhai': 'No declarations for this tax code.',
  'crm.cdt.nghinUsdLoSo': 'thousand USD · shipments · vs same period',
  'crm.cdt.goiYKhaiThue': 'Customs brokerage suggested',
  'crm.cdt.taoCoHoiBan': 'Create opportunity',
  'crm.cdt.khachDangHopTac': 'Active customer',
  'crm.cdt.giuDoVuotHan': 'DO hold · over limit',
  'crm.cdt.thuLai': 'Retry',
  'crm.cdt.veDanhSach': 'Back to list',
  'crm.cdt.khachChuaCoJob': 'No jobs for this customer. Click “+ Create job” or send a quote first.',
  'crm.cdt.chuaGhiTuongTac': 'No interactions logged.',
  'crm.cdt.khongCoViec': 'No tasks.',
  'crm.cdt.6Thang': '6 months',
  'crm.cdt.chuaDungTrongJob': 'Not used in any job in the last 90 days.',
  'crm.cdt.khongConViecNao': 'No tasks left for this profile.',
  'crm.cdt.ganLoai': 'Assign type',
  'crm.cdt.themLienHe': 'Add contact',
  'crm.cdt.chuaCoLienHe3': 'No contacts yet. Add an order / payment recipient before using this partner on a job.',
  'crm.cdt.themTaiKhoan': 'Add account',
  'crm.cdt.chuaCoTaiKhoan3': 'No accounts yet. Add one and check VietQR to match the account holder before raising a payment request.',
  'crm.cdt.xemVaSuaO': 'View and edit in Rate setup ›',
  'crm.cdt.localChargeChiAp': 'Local charges only apply to CARRIER / COLOADER partners.',
  'crm.cdt.chuaLuuTaiKhoan': 'No portal accounts saved.',
  'crm.cdt.ghiChu': 'Notes',
  'crm.cdt.sua': 'Edit',
  'crm.cdt.xoa': 'Delete',
  'crm.cdt.taiTep': 'Upload file',
  'crm.cdt.cachTinhHanTra': 'Due-date rule',
  'crm.cdt.soNgaySauHoa': 'Days after invoice',
  'crm.cdt.ngayChotTrongThang': 'Cut-off day of month',
  'crm.cdt.soNgayTinhTu': 'Days from ETA / ETD',
  'crm.cdt.luuDieuKhoan': 'Save terms',
});

addMessages('vi', {
  'crm.cda.k1': 'Liên hệ chính',
  'crm.cda.k2': 'Liên hệ',
  'crm.cda.k3': 'Nhận thư theo loại',
  'crm.cda.k4': 'Số liên hệ đang nhận từng loại thư / thông báo tự động. Loại chưa có ai nhận hiện cảnh báo; bấm ô tick ở bảng bên trái để đổi.',
  'crm.cda.k5': 'Nhập liên hệ',
  'crm.cda.k6': 'Hợp đồng dịch vụ',
  'crm.cda.k7': 'Hợp đồng dịch vụ và phụ lục. Báo giá Live ở cột phải.',
  'crm.cda.k8': 'Báo Zalo (ZNS) theo mốc job',
  'crm.cda.k9': 'Bật / tắt báo ZNS cho từng mốc và chọn liên hệ nhận.',
  'crm.cda.k10': 'Chỉ người liên hệ gắn vai kế toán',
  'crm.cda.k11': 'Tài khoản nhận tiền',
  'crm.cda.k12': 'Dùng khi HANA hoàn tiền (refund, cược cont) · TblPartnerBank · số tài khoản che 4 số cuối · Tài khoản mới về Chờ xác minh · người nhập không tự xác minh · xác minh bởi ghế [ACC-AR] / [ACC-CA] / BOD.',
  'crm.cda.k13': 'Cấu hình riêng',
  'crm.cda.k14': 'Tương tác',
  'crm.cda.k15': 'Lọc theo loại; + Ghi tương tác lưu vào TblEntityInteraction.',
  'crm.cda.k16': 'Loại tương tác',
  'crm.cda.k17': 'Hoá đơn chưa thu',
  'crm.cda.k18': 'Số tiền ẩn',
  'crm.cda.k19': 'Người dùng myHANA',
  'crm.cda.k20': 'Khách xem tracking, chứng từ, hoá đơn. Không thấy giá vốn, lợi nhuận.',
  'crm.cda.k21': 'Ghi chú nghiệp vụ',
  'crm.cda.k22': 'Wiki của GREENBUD · ai trong team cũng đọc được',
  'crm.cda.k23': 'Thư viện tệp',
  'crm.cda.k24': 'Giấy phép, hợp đồng, mẫu chứng từ, danh thiếp · mở bằng Trình xem tệp',
  'crm.cda.k25': 'Job của khách',
  'crm.cda.k26': 'Job trước ngày chuyển / chia vẫn giữ Sale cũ.',
  'crm.cda.k27': 'Lọc trạng thái job',
  'crm.cda.k28': 'Đã xuất HĐ',
  'crm.cda.k29': 'Hoàn phí của khách',
  'crm.cda.k30': 'Gom theo khách từ các job · số tiền xem ở Phải trả (màn tài chính)',
  'crm.cda.k31': 'Kỳ theo ngày job',
  'crm.cda.k32': 'Dòng hoặc phiếu của đối tác',
  'crm.cda.k33': 'Cần quyền tiền (ACC · BOD) để xem USD/cont, số tiền và tổng phải chi',
  'crm.cda.k34': 'Lọc trạng thái',
  'crm.cda.k35': 'Tìm job, HBL, tuyến, Sale',
  'crm.cda.k36': 'Job · tuyến · Sale',
  'crm.cda.k37': 'Lọc thêm',
  'crm.cda.k38': 'Trùng KB cùng người nhận trên job',
  'crm.cda.k39': 'Cần quyền tiền',
  'crm.cda.k40': 'Phiếu RFD',
  'crm.cda.k41': 'Tổng quan refund',
  'crm.cda.k42': 'Như tab Refund LOGI: tổng refund, dòng / job, tỷ lệ job có refund, job trong kỳ chưa có refund (đếm độc lập BOOKINGDATA).',
  'crm.cda.k43': 'Thao tác',
  'crm.cda.k44': 'Đồng bộ tỷ giá (Sync ROE) cho dòng Amount = 0; Tạo RFD gom dòng Chờ gom, tự tách mỗi người nhận một phiếu.',
  'crm.cda.k45': 'Cảnh báo',
  'crm.cda.k46': 'Thiếu khai = job trong kỳ chưa có dòng; thiếu tỷ giá chặn gom RFD; trùng KB = cùng job, cùng người nhận ≥ 2 dòng. Bấm để lọc.',
  'crm.cda.k47': 'Ghế duyệt',
  'crm.cda.k48': 'Ghế ACC-CA duyệt · trống thì lên cấp trên.',
  'crm.cda.k49': 'Người nhận',
  'crm.cda.k50': 'Collaborator: liên hệ của đối tác có cờ Collaborator. Tên và tài khoản nhận che ••••. Bấm để lọc theo người nhận.',
  'crm.cda.k51': 'Trạng thái',
  'crm.cda.k52': 'Chờ gom → Chờ duyệt → Chờ chi → Đã chi. Bấm để lọc.',
  'crm.cda.k53': '6 kỳ',
  'crm.cda.k54': '3 kỳ trước là số minh hoạ theo tỷ trọng đối tác.',
  'crm.cda.k55': 'Kỳ',
  'crm.cda.k56': 'Job theo tháng',
  'crm.cda.k57': 'Đo bằng số job, TEU, cut-off.',
  'crm.cda.k58': 'Theo tuyến',
  'crm.cda.k59': 'Tỷ trọng job theo tuyến và hãng chính.',
  'crm.cda.k60': 'Kim ngạch xuất khẩu',
  'crm.cda.k61': 'Tổng quan theo kỳ so với cùng kỳ',
  'crm.cda.k62': 'Thị phần HANA',
  'crm.cda.k63': 'Ai nắm cước',
  'crm.cda.k64': 'Top nước / cảng đến',
  'crm.cda.k65': 'Top người mua',
  'crm.cda.k66': 'Top mặt hàng (HS)',
  'crm.cda.k67': 'Phương thức vận tải và chi cục hải quan',
  'crm.cda.k68': 'Ask HANA gợi ý',
  'crm.cda.k69': 'Ask HANA đọc kim ngạch, thị phần, điều kiện giao hàng và chi cục ở cột trái rồi gợi ý việc nên làm. Kiểm lại trước khi chào khách. “Tạo cơ hội bán hàng” mở form điền sẵn tuyến.',
  'crm.cda.k70': 'Cơ hội',
  'crm.cda.k71': 'Tuyến khách đi nhiều mà HANA chưa làm và dịch vụ đi kèm lô hàng (kiểm dịch, CO, khai thuê). Đếm theo lô / tờ khai, không phải tiền.',
  'crm.cda.k72': 'Liên kết',
  'crm.cda.k73': 'Về danh sách khách hàng',
  'crm.cda.k74': 'Thông báo',
  'crm.cda.k75': 'Thao tác khác',
  'crm.cda.k76': 'Nhóm thông tin khách',
  'crm.cda.k77': 'Job gần đây',
  'crm.cda.k78': 'Job mới nhất của khách.',
  'crm.cda.k79': 'Tỷ trọng job theo tuyến và hãng chính · kỳ chọn ở tab Hiệu suất.',
  'crm.cda.k80': 'Kim ngạch xuất khẩu · 12 tháng',
  'crm.cda.k81': 'Giá trị hàng xuất của khách theo tờ khai hải quan (theo MST). Không phải số liệu tài chính của HANA.',
  'crm.cda.k82': 'Pháp nhân',
  'crm.cda.k83': 'Tương tác gần nhất',
  'crm.cda.k84': 'Hoạt động hồ sơ',
  'crm.cda.k85': 'Cột phải hồ sơ khách',
  'crm.cda.k86': 'Việc cần làm',
  'crm.cda.k87': 'Thông tin chính',
  'crm.cda.k88': 'Hồ sơ gốc của khách (TblClient).',
  'crm.cda.k89': 'Người phụ trách',
  'crm.cda.k90': 'Công nợ',
  'crm.cda.k91': 'Công nợ tóm tắt',
});

addMessages('en', {
  'crm.cda.k1': 'Primary contact',
  'crm.cda.k2': 'Contacts',
  'crm.cda.k3': 'Mail by type',
  'crm.cda.k4': 'Contacts receiving each type of automatic mail / notification. Types with no recipient show a warning; tick the box in the left table to change.',
  'crm.cda.k5': 'Import contacts',
  'crm.cda.k6': 'Service contracts',
  'crm.cda.k7': 'Service contracts and addenda. Live quotes in the right column.',
  'crm.cda.k8': 'Zalo (ZNS) by job milestone',
  'crm.cda.k9': 'Turn ZNS on / off per milestone and choose the receiving contact.',
  'crm.cda.k10': 'Only contacts with the accounting role',
  'crm.cda.k11': 'Refund receiving account',
  'crm.cda.k12': 'Used when HANA refunds (refund, cont deposit) · TblPartnerBank · account number masked except last 4 digits · new accounts start as Pending verification · the person who enters it cannot verify · verified by seat [ACC-AR] / [ACC-CA] / BOD.',
  'crm.cda.k13': 'Custom settings',
  'crm.cda.k14': 'Interactions',
  'crm.cda.k15': 'Filter by type; + Log interaction saves to TblEntityInteraction.',
  'crm.cda.k16': 'Interaction type',
  'crm.cda.k17': 'Unpaid invoices',
  'crm.cda.k18': 'Amount hidden',
  'crm.cda.k19': 'myHANA users',
  'crm.cda.k20': 'Customer sees tracking, documents, invoices. No cost or profit shown.',
  'crm.cda.k21': 'Business notes',
  'crm.cda.k22': 'GREENBUD wiki · anyone on the team can read it',
  'crm.cda.k23': 'File library',
  'crm.cda.k24': 'Licences, contracts, document templates, business cards · open with the file viewer',
  'crm.cda.k25': 'Customer jobs',
  'crm.cda.k26': 'Jobs before the transfer / split date stay with the previous Sale.',
  'crm.cda.k27': 'Filter job status',
  'crm.cda.k28': 'Invoiced',
  'crm.cda.k29': 'Customer refunds',
  'crm.cda.k30': 'Grouped by customer from jobs · amounts are in Payables (finance screen)',
  'crm.cda.k31': 'Period by job date',
  'crm.cda.k32': 'Partner lines or vouchers',
  'crm.cda.k33': 'Money permission (ACC · BOD) required to see USD/cont, amounts and total payable',
  'crm.cda.k34': 'Filter status',
  'crm.cda.k35': 'Search job, HBL, route, Sale',
  'crm.cda.k36': 'Job · route · Sale',
  'crm.cda.k37': 'More filters',
  'crm.cda.k38': 'Duplicate KB, same recipient on the job',
  'crm.cda.k39': 'Money permission required',
  'crm.cda.k40': 'RFD vouchers',
  'crm.cda.k41': 'Refund overview',
  'crm.cda.k42': 'As in the LOGI Refund tab: total refund, lines / job, share of jobs with refund, jobs in period without refund (counted independently from BOOKINGDATA).',
  'crm.cda.k43': 'Actions',
  'crm.cda.k44': 'Sync exchange rate (Sync ROE) for lines with Amount = 0; Create RFD groups lines awaiting grouping, one voucher per recipient.',
  'crm.cda.k45': 'Alerts',
  'crm.cda.k46': 'Missing entry = job in period with no line; missing rate blocks RFD grouping; duplicate KB = same job, same recipient, 2+ lines. Click to filter.',
  'crm.cda.k47': 'Approval seat',
  'crm.cda.k48': 'Seat ACC-CA approves · if empty, escalates to the superior.',
  'crm.cda.k49': 'Recipient',
  'crm.cda.k50': 'Collaborator: partner contacts flagged Collaborator. Name and receiving account masked ••••. Click to filter by recipient.',
  'crm.cda.k51': 'Status',
  'crm.cda.k52': 'Awaiting grouping → Awaiting approval → Awaiting payment → Paid. Click to filter.',
  'crm.cda.k53': '6 periods',
  'crm.cda.k54': 'The 3 earlier periods are illustrative, split by partner share.',
  'crm.cda.k55': 'Period',
  'crm.cda.k56': 'Jobs by month',
  'crm.cda.k57': 'Measured in jobs, TEU, cut-off.',
  'crm.cda.k58': 'By route',
  'crm.cda.k59': 'Job share by route and main carrier.',
  'crm.cda.k60': 'Export value',
  'crm.cda.k61': 'Period overview vs same period',
  'crm.cda.k62': 'HANA market share',
  'crm.cda.k63': 'Who controls freight',
  'crm.cda.k64': 'Top destination countries / ports',
  'crm.cda.k65': 'Top buyers',
  'crm.cda.k66': 'Top goods (HS)',
  'crm.cda.k67': 'Transport mode and customs office',
  'crm.cda.k68': 'Ask HANA suggests',
  'crm.cda.k69': 'Ask HANA reads export value, market share, delivery terms and customs offices in the left column, then suggests actions. Verify before pitching the customer. “Create sales opportunity” opens a form pre-filled with the route.',
  'crm.cda.k70': 'Opportunities',
  'crm.cda.k71': 'Routes the customer ships often that HANA does not handle, and services attached to shipments (quarantine, CO, customs brokerage). Counted per shipment / declaration, not money.',
  'crm.cda.k72': 'Links',
  'crm.cda.k73': 'Back to customer list',
  'crm.cda.k74': 'Notifications',
  'crm.cda.k75': 'More actions',
  'crm.cda.k76': 'Customer info groups',
  'crm.cda.k77': 'Recent jobs',
  'crm.cda.k78': 'Latest jobs of the customer.',
  'crm.cda.k79': 'Job share by route and main carrier · period chosen in the Performance tab.',
  'crm.cda.k80': 'Export value · 12 months',
  'crm.cda.k81': 'Customer export value from customs declarations (by tax code). Not HANA financial figures.',
  'crm.cda.k82': 'Legal entity',
  'crm.cda.k83': 'Latest interaction',
  'crm.cda.k84': 'Profile activity',
  'crm.cda.k85': 'Customer profile right column',
  'crm.cda.k86': 'To-do',
  'crm.cda.k87': 'Main info',
  'crm.cda.k88': 'Customer master record (TblClient).',
  'crm.cda.k89': 'Owner',
  'crm.cda.k90': 'Receivables',
  'crm.cda.k91': 'Receivables summary',
});

addMessages('vi', {
  'crm.x.addContact': 'Thêm liên hệ',
  'crm.x.edit': 'Sửa',
  'crm.x.delete': 'Xoá',
  'crm.x.importXlsx': 'Nhập từ Excel',
  'crm.x.openPrintCt': 'Mở / in hợp đồng',
  'crm.x.znsTpl': 'Mẫu ZNS',
  'crm.x.addAccount': 'Thêm tài khoản',
  'crm.x.logInteraction': 'Ghi tương tác',
  'crm.x.inviteUser': 'Mời người dùng',
  'crm.x.note': 'Ghi chú',
  'crm.x.upload': 'Tải tệp',
  'crm.x.openPayable': 'Mở Phải trả ›',
  'crm.x.payRequest': 'Yêu cầu thanh toán',
  'crm.x.printSlip': 'In phiếu',
  'crm.x.moneyHidden': 'Số tiền ẩn ••••',
  'crm.x.filter': 'Lọc',
  'crm.x.createJob': 'Tạo job',
  'crm.x.analyze': 'Phân tích',
  'crm.x.lookupTax': 'Tra lại MST',
  'crm.x.viewAll': 'Xem tất cả',
  'crm.x.handoverSale': 'Chuyển Sale',
  'crm.x.detail': 'Chi tiết',
  'crm.x.overLimit': 'Vượt hạn mức',
  'crm.x.exportCsv': 'Xuất CSV',
  'crm.x.add': 'Thêm',
  'crm.x.askPartnerPrice': 'Hỏi giá đối tác',
  'crm.x.createInq': 'Tạo phiếu',
  'crm.x.ownOnly': 'Chỉ xem phiếu của bạn.',
  'crm.x.confirm': 'Xác nhận',
  'crm.x.acceptInq': 'Nhận thành phiếu',
  'crm.x.quote': 'Báo giá',
  'crm.x.setFollow': 'Đặt / dời ngày follow',
  'crm.x.teamNeedSeat': 'Xem cả nhóm cần ghế [SAL-MGR].',
  'crm.x.logFollow': 'Ghi kết quả follow',
  'crm.x.save': 'Lưu',
  'crm.x.call': 'Gọi',
});
addMessages('en', {
  'crm.x.addContact': 'Add contact',
  'crm.x.edit': 'Edit',
  'crm.x.delete': 'Delete',
  'crm.x.importXlsx': 'Import from Excel',
  'crm.x.openPrintCt': 'Open / print contract',
  'crm.x.znsTpl': 'ZNS templates',
  'crm.x.addAccount': 'Add account',
  'crm.x.logInteraction': 'Log interaction',
  'crm.x.inviteUser': 'Invite user',
  'crm.x.note': 'Note',
  'crm.x.upload': 'Upload file',
  'crm.x.openPayable': 'Open Payable ›',
  'crm.x.payRequest': 'Payment request',
  'crm.x.printSlip': 'Print slip',
  'crm.x.moneyHidden': 'Amount hidden ••••',
  'crm.x.filter': 'Filter',
  'crm.x.createJob': 'Create job',
  'crm.x.analyze': 'Analyze',
  'crm.x.lookupTax': 'Look up tax ID again',
  'crm.x.viewAll': 'View all',
  'crm.x.handoverSale': 'Reassign Sale',
  'crm.x.detail': 'Details',
  'crm.x.overLimit': 'Over limit',
  'crm.x.exportCsv': 'Export CSV',
  'crm.x.add': 'Add',
  'crm.x.askPartnerPrice': 'Ask partner for price',
  'crm.x.createInq': 'Create inquiry',
  'crm.x.ownOnly': 'You can only see your own inquiries.',
  'crm.x.confirm': 'Confirm',
  'crm.x.acceptInq': 'Accept as inquiry',
  'crm.x.quote': 'Quote',
  'crm.x.setFollow': 'Set / move follow-up date',
  'crm.x.teamNeedSeat': 'Viewing the whole team needs the [SAL-MGR] seat.',
  'crm.x.logFollow': 'Log follow-up result',
  'crm.x.save': 'Save',
  'crm.x.call': 'Call',
});

addMessages('vi', {
  "crm.at.1": "Tự gia hạn",
  "crm.at.2": "Lọc nhanh",
  "crm.at.3": "Tỉnh / thành",
  "crm.at.4": "Khách hàng",
  "crm.at.5": "Về mục Thêm",
  "crm.at.6": "Lọc danh bạ",
  "crm.at.7": "Thêm khách",
  "crm.at.8": "Tìm khách",
  "crm.at.9": "Tên khách / MST",
  "crm.at.10": "Nhóm",
  "crm.at.11": "Quay lại danh sách khách",
  "crm.at.12": "Gọi đầu mối",
  "crm.at.13": "Ghi tương tác",
  "crm.at.14": "Khách 360",
  "crm.at.15": "Pháp nhân",
  "crm.at.16": "Tên, MST, địa chỉ theo đăng ký kinh doanh.",
  "crm.at.17": "Liên hệ",
  "crm.at.18": "Người nhận chứng từ, hoá đơn; Gọi / Mail trực tiếp.",
  "crm.at.19": "Cột phải khách 360",
  "crm.at.20": "Việc cần làm",
  "crm.at.21": "Thông tin chính",
  "crm.at.22": "Hồ sơ gốc của khách (TblClient).",
  "crm.at.23": "Người phụ trách",
  "crm.at.24": "Liên kết",
  "crm.at.25": "Tổng hợp",
  "crm.at.26": "Khách theo Sale",
  "crm.at.27": "Theo tỉnh / vùng",
  "crm.at.28": "Theo hạng khách",
  "crm.at.29": "Lâu chưa có job",
  "crm.at.30": "Về danh sách đối tác",
  "crm.at.31": "Thông báo",
  "crm.at.32": "Thao tác khác",
  "crm.at.33": "Nhóm thông tin đối tác",
  "crm.at.34": "Pháp lý",
  "crm.at.35": "Tên, MST, địa chỉ VN / EN theo đăng ký; Sửa mở ngăn kéo pháp lý.",
  "crm.at.36": "Sửa",
  "crm.at.37": "Hiệu suất · job dùng đối tác",
  "crm.at.38": "Hiệu suất",
  "crm.at.39": "Đếm job dùng đối tác 6 tháng, không hiện tiền.",
  "crm.at.40": "Hoạt động",
  "crm.at.41": "Nhật ký hồ sơ đối tác (trước ở cột phải · Hoạt động).",
  "crm.at.42": "Cột phải hồ sơ đối tác",
  "crm.at.43": "Trạng thái hồ sơ (trước ở cột phải) và trường chính.",
  "crm.at.44": "Vai & loại đối tác",
  "crm.at.45": "Vai và loại",
  "crm.at.46": "Vai (Supplier / Customer / Agent) và loại đối tác (CARRIER, COLOADER…).",
  "crm.at.47": "Người giữ ghế theo cơ cấu (TblOrgAssign); avatar theo TblStaff.ImageProfile.",
  "crm.at.48": "Đi nhanh sang màn liên quan.",
  "crm.at.49": "Cờ nhận thư quyết định ai nhận BKCF, Debit, thanh toán… tự động",
  "crm.at.50": "Tài khoản nhận tiền",
  "crm.at.51": "TblPartnerBank · phiếu chi chỉ chi vào tài khoản đã xác minh · số tài khoản che 4 số cuối",
  "crm.at.52": "Đặt mặc định",
  "crm.at.53": "Local charge của hãng",
  "crm.at.54": "Bộ local charge của hãng sửa ở Thiết lập giá. · Bộ local charge theo loại cont, theo phiên bản, và Hana đọc thông báo local charge của hãng đều làm ở Mint-PriceSetup. Hồ sơ hãng chỉ dẫn link.",
  "crm.at.55": "Tài khoản cổng hãng / đối tác",
  "crm.at.56": "Tài khoản cổng",
  "crm.at.57": "Mật khẩu mã hoá, hiện tối đa 10 giây, mỗi lần hiện / chép ghi lịch sử.",
  "crm.at.58": "Chép",
  "crm.at.59": "Ghi chú nghiệp vụ",
  "crm.at.60": "Thư viện tệp",
  "crm.at.61": "Giấy phép, hợp đồng, mẫu chứng từ, danh thiếp · mở bằng Trình xem tệp",
  "crm.at.62": "Lịch sử",
  "crm.at.63": "Toàn bộ thay đổi hồ sơ đối tác.",
  "crm.at.64": "Điều khoản thanh toán cho nhà cung cấp",
  "crm.at.65": "Điều khoản thanh toán",
  "crm.at.66": "Cách tính hạn trả theo hoá đơn / ngày chốt / ETA–ETD.",
  "crm.at.67": "Cách tính hạn",
  "crm.at.68": "Hoá đơn trước ngày chốt trả trong tháng, sau ngày chốt trả tháng sau",
  "crm.at.69": "Cơ hội bán hàng",
  "crm.at.70": "Kiểu xem",
  "crm.at.71": "Mở cột phải",
  "crm.at.72": "Tìm phiếu",
  "crm.at.73": "Mã phiếu / ShortName / số báo giá",
  "crm.at.74": "Lọc theo PIC",
  "crm.at.75": "Phiếu nháp Hana",
  "crm.at.76": "Bỏ",
  "crm.at.77": "Chưa gắn phiếu",
  "crm.at.78": "Phiếu theo giai đoạn",
  "crm.at.79": "Danh sách phiếu",
  "crm.at.80": "Phiếu",
  "crm.at.81": "Phạm vi",
  "crm.at.82": "Về danh sách",
  "crm.at.83": "Lý do",
  "crm.at.84": "Đối thủ",
  "crm.at.85": "Đối thủ (nếu biết)",
  "crm.at.86": "Ngày follow",
  "crm.at.87": "Cơ hội",
  "crm.at.88": "Giai đoạn",
  "crm.at.89": "Phễu cơ hội",
  "crm.at.90": "Đóng 30 ngày",
  "crm.at.91": "Hệ thống tự làm",
  "crm.at.92": "Nhịp việc",
  "crm.at.93": "Đánh dấu xong",
  "crm.at.94": "Về Hôm nay",
  "crm.at.95": "Kết quả",
  "crm.at.96": "Ghi chú",
  "crm.at.97": "Khách nói gì…",
  "crm.at.98": "Hẹn tiếp",
  "crm.at.99": "Hôm nay",
  "crm.at.100": "Khách cần xử lý",
  "crm.at.101": "Việc của khách",
  "crm.at.102": "Sổ tay của tôi",
  "crm.at.103": "Ghi nhanh một việc…",
});

addMessages('en', {
  "crm.at.1": "Auto-renew",
  "crm.at.2": "Quick filter",
  "crm.at.3": "Province / city",
  "crm.at.4": "Customers",
  "crm.at.5": "Back to More",
  "crm.at.6": "Filter contacts",
  "crm.at.7": "Add customer",
  "crm.at.8": "Search customers",
  "crm.at.9": "Customer name / tax ID",
  "crm.at.10": "Group",
  "crm.at.11": "Back to customer list",
  "crm.at.12": "Call contact",
  "crm.at.13": "Log interaction",
  "crm.at.14": "Customer 360",
  "crm.at.15": "Legal entity",
  "crm.at.16": "Name, tax ID, address as per business registration.",
  "crm.at.17": "Contacts",
  "crm.at.18": "Recipients of documents and invoices; call / mail directly.",
  "crm.at.19": "Customer 360 right panel",
  "crm.at.20": "To do",
  "crm.at.21": "Main info",
  "crm.at.22": "Customer master record (TblClient).",
  "crm.at.23": "Owner",
  "crm.at.24": "Links",
  "crm.at.25": "Summary",
  "crm.at.26": "Customers by Sales",
  "crm.at.27": "By province / region",
  "crm.at.28": "By customer tier",
  "crm.at.29": "No job for a long time",
  "crm.at.30": "Back to partner list",
  "crm.at.31": "Notifications",
  "crm.at.32": "More actions",
  "crm.at.33": "Partner info groups",
  "crm.at.34": "Legal",
  "crm.at.35": "Name, tax ID, VN / EN address as registered; Edit opens the legal drawer.",
  "crm.at.36": "Edit",
  "crm.at.37": "Performance · jobs using partner",
  "crm.at.38": "Performance",
  "crm.at.39": "Jobs using the partner over 6 months, no money shown.",
  "crm.at.40": "Activity",
  "crm.at.41": "Partner record log (formerly in right panel · Activity).",
  "crm.at.42": "Partner record right panel",
  "crm.at.43": "Record status (formerly in right panel) and main fields.",
  "crm.at.44": "Partner role & type",
  "crm.at.45": "Role and type",
  "crm.at.46": "Role (Supplier / Customer / Agent) and partner type (CARRIER, COLOADER…).",
  "crm.at.47": "Seat holder per org structure (TblOrgAssign); avatar from TblStaff.ImageProfile.",
  "crm.at.48": "Jump to related screens.",
  "crm.at.49": "Mail flags decide who automatically receives BKCF, Debit, payments…",
  "crm.at.50": "Payee accounts",
  "crm.at.51": "TblPartnerBank · payment vouchers only pay to verified accounts · account number masked except last 4 digits",
  "crm.at.52": "Set as default",
  "crm.at.53": "Carrier local charges",
  "crm.at.54": "Carrier local charge sets are edited in Price setup. · Sets by container type, by version, and Hana reading carrier local charge notices are all done in Mint-PriceSetup. The carrier record only links there.",
  "crm.at.55": "Carrier / partner portal accounts",
  "crm.at.56": "Portal accounts",
  "crm.at.57": "Password is encrypted, shown for at most 10 seconds; every reveal / copy is logged.",
  "crm.at.58": "Copy",
  "crm.at.59": "Business notes",
  "crm.at.60": "File library",
  "crm.at.61": "Licences, contracts, document templates, business cards · open in File viewer",
  "crm.at.62": "History",
  "crm.at.63": "All changes to the partner record.",
  "crm.at.64": "Payment terms for supplier",
  "crm.at.65": "Payment terms",
  "crm.at.66": "How due dates are computed by invoice / cut-off day / ETA–ETD.",
  "crm.at.67": "Due-date method",
  "crm.at.68": "Invoices before the cut-off day are paid this month, after it next month",
  "crm.at.69": "Sales opportunities",
  "crm.at.70": "View mode",
  "crm.at.71": "Open right panel",
  "crm.at.72": "Search tickets",
  "crm.at.73": "Ticket ID / ShortName / quote no.",
  "crm.at.74": "Filter by PIC",
  "crm.at.75": "Hana draft tickets",
  "crm.at.76": "Dismiss",
  "crm.at.77": "Unlinked",
  "crm.at.78": "Tickets by stage",
  "crm.at.79": "Ticket list",
  "crm.at.80": "Ticket",
  "crm.at.81": "Scope",
  "crm.at.82": "Back to list",
  "crm.at.83": "Reason",
  "crm.at.84": "Competitor",
  "crm.at.85": "Competitor (if known)",
  "crm.at.86": "Follow-up date",
  "crm.at.87": "Opportunity",
  "crm.at.88": "Stage",
  "crm.at.89": "Opportunity funnel",
  "crm.at.90": "Closed in 30 days",
  "crm.at.91": "Automated by system",
  "crm.at.92": "Task rhythm",
  "crm.at.93": "Mark done",
  "crm.at.94": "Back to Today",
  "crm.at.95": "Result",
  "crm.at.96": "Note",
  "crm.at.97": "What did the customer say…",
  "crm.at.98": "Next follow-up",
  "crm.at.99": "Today",
  "crm.at.100": "Customers to handle",
  "crm.at.101": "Customer tasks",
  "crm.at.102": "My notebook",
  "crm.at.103": "Jot down a task…",
});

addMessages('vi', { 'crm.at.h1': 'Việc sinh từ hồ sơ: thiếu liên hệ, vượt hạn mức, myHANA chờ duyệt.' });
addMessages('en', { 'crm.at.h1': 'Tasks generated from the record: missing contact, over credit limit, myHANA pending approval.' });

addMessages('vi', { 'crm.at.h2': 'Việc sinh từ hồ sơ: chờ duyệt, trùng ShortName / MST, chưa gắn loại, chưa có liên hệ, tài khoản nhận tiền chờ xác minh (maker–checker).' });
addMessages('en', { 'crm.at.h2': 'Tasks generated from the record: pending approval, duplicate ShortName / tax ID, no type set, no contact, payee account awaiting verification (maker–checker).' });

addMessages('vi', {
  'crm.pb.noWrite': 'Chưa mở ghi ở bản này',
  'crm.pb.noDetail': 'Chi tiết phiếu chưa mở ở bản này',
  'crm.pb.openN': '{n} phiếu mở',
  'crm.pb.overdueN': '{n} quá hạn follow',
  'crm.pb.emptyT': 'Chưa có dữ liệu',
  'crm.pb.emptyD': 'Chưa có phiếu hỏi giá nào.',
  'crm.pb.pendingN': '{n} chờ xác nhận',
  'crm.pb.openDeal': 'Mở phiếu {id} · {c}',
  'crm.pb.backDeal': 'Lùi {id} về {v}',
  'crm.pb.moveDeal': 'Chuyển {id} sang {v}',
  'crm.pb.foot': '{n} phiếu · bấm dòng để mở',
  'crm.pb.tabList': 'Danh sách',
  'crm.pb.th.deal': 'Phiếu',
  'crm.pb.th.cust': 'Khách',
  'crm.pb.th.topic': 'Chủ đề',
  'crm.pb.th.svc': 'Dịch vụ',
  'crm.pb.th.stage': 'Giai đoạn',
  'crm.pb.th.follow': 'Follow',
  'crm.pb.th.quote': 'Báo giá',
  'crm.pb.th.pricing': 'Pricing',
  'crm.pb.th.sale': 'Sale',
});

addMessages('en', {
  'crm.pb.noWrite': 'Writing is not enabled in this version',
  'crm.pb.noDetail': 'Deal details are not available in this version',
  'crm.pb.openN': '{n} open',
  'crm.pb.overdueN': '{n} follow-up overdue',
  'crm.pb.emptyT': 'No data yet',
  'crm.pb.emptyD': 'No rate inquiries yet.',
  'crm.pb.pendingN': '{n} awaiting confirmation',
  'crm.pb.openDeal': 'Open deal {id} · {c}',
  'crm.pb.backDeal': 'Move {id} back to {v}',
  'crm.pb.moveDeal': 'Move {id} to {v}',
  'crm.pb.foot': '{n} deals · click a row to open',
  'crm.pb.tabList': 'List',
  'crm.pb.th.deal': 'Deal',
  'crm.pb.th.cust': 'Customer',
  'crm.pb.th.topic': 'Topic',
  'crm.pb.th.svc': 'Service',
  'crm.pb.th.stage': 'Stage',
  'crm.pb.th.follow': 'Follow-up',
  'crm.pb.th.quote': 'Quote',
  'crm.pb.th.pricing': 'Pricing',
  'crm.pb.th.sale': 'Sale',
  'crm.pd.mst': 'Tax ID {v}',
  'crm.pd.jobMonth': 'Jobs for {id} by month: {v}',
  'crm.pd.nJob': '{m}: {n} jobs',
  'crm.pd.contacts': 'Contacts · {n}',
  'crm.pd.edit': 'Edit {n}',
  'crm.pd.del': 'Delete {n}',
  'crm.pd.banks': 'Payout accounts · {n}',
  'crm.pd.pause': 'Stop using account {n}',
  'crm.pd.hidePw': 'Hide password {k}',
  'crm.pd.showPw': 'Show password {k}',
  'crm.pd.hide': 'Hide',
  'crm.pd.show': 'Show',
  'crm.pd.editNote': 'Edit note {n}',
  'crm.pd.delNote': 'Delete note {n}',
  'crm.pd.view': 'View {n}',
  'crm.pd.noViewer': 'File viewer is not enabled in this version',
  'crm.pd.viewBtn': 'View',
});

addMessages('vi', {
  'crm.cdt.ov': 'Tổng quan',
  'crm.cdt.ct': 'Liên hệ',
  'crm.cdt.perf': 'Hiệu suất',
  'crm.cdt.kn': 'Kim ngạch',
  'crm.cdt.ix': 'Tương tác',
  'crm.cdt.cfg': 'Hợp đồng & cấu hình',
  'crm.cdt.ar': 'Công nợ',
  'crm.cdt.wiki': 'Wiki & tệp',
  'crm.cdz.ok': 'Đã duyệt',
  'crm.cdz.okTip': 'gửi tự động khi job tới mốc',
  'crm.cdz.wait': 'Chờ duyệt',
  'crm.cdz.waitTip': 'chờ Zalo duyệt, chưa gửi',
  'crm.cdz.rej': 'Bị từ chối',
  'crm.cdz.rejTip': 'Zalo từ chối, chưa gửi được · sửa ở Mẫu ZNS',
  'crm.cdz.zalo.follow': 'Follow',
  'crm.cdz.zalo.unfollow': 'Bỏ follow',
  'crm.cdz.zalo.none': 'Chưa liên kết',
  'crm.cdr.f.all': 'Tất cả',
  'crm.cdr.f.pend': 'Chờ gom',
  'crm.cdr.f.wait': 'Chờ duyệt',
  'crm.cdr.f.chi': 'Chờ chi',
  'crm.cdr.f.paid': 'Đã chi',
  'crm.cdr.f.nil': 'Không refund',
  'crm.cdr.c.roe': 'Thiếu tỷ giá',
  'crm.cdr.c.dup': 'Trùng KB',
  'crm.cdr.c.dbn': 'Khách chưa trả DN',
  'crm.cdr.unfilter': 'Bỏ lọc {v}',
});

addMessages('en', {
  'crm.cdt.ov': 'Overview',
  'crm.cdt.ct': 'Contacts',
  'crm.cdt.perf': 'Performance',
  'crm.cdt.kn': 'Trade volume',
  'crm.cdt.ix': 'Interactions',
  'crm.cdt.cfg': 'Contract & settings',
  'crm.cdt.ar': 'Receivables',
  'crm.cdt.wiki': 'Wiki & files',
  'crm.cdz.ok': 'Approved',
  'crm.cdz.okTip': 'sent automatically when the job reaches the milestone',
  'crm.cdz.wait': 'Pending approval',
  'crm.cdz.waitTip': 'awaiting Zalo approval, not sent',
  'crm.cdz.rej': 'Rejected',
  'crm.cdz.rejTip': 'rejected by Zalo, cannot send · fix in ZNS templates',
  'crm.cdz.zalo.follow': 'Follow',
  'crm.cdz.zalo.unfollow': 'Unfollowed',
  'crm.cdz.zalo.none': 'Not linked',
  'crm.cdr.f.all': 'All',
  'crm.cdr.f.pend': 'To collect',
  'crm.cdr.f.wait': 'Pending approval',
  'crm.cdr.f.chi': 'To pay',
  'crm.cdr.f.paid': 'Paid',
  'crm.cdr.f.nil': 'No refund',
  'crm.cdr.c.roe': 'Missing ROE',
  'crm.cdr.c.dup': 'Duplicate KB',
  'crm.cdr.c.dbn': 'Customer unpaid DN',
  'crm.cdr.unfilter': 'Clear filter {v}',
});

addMessages('vi', {
  'crm.cdk.new': 'Khách mới tháng 10',
  'crm.cdk.overdue': 'Có công nợ quá hạn',
  'crm.cdk.myWait': 'Chờ BOD duyệt myHANA',
  'crm.cdk.noProv': 'Chưa có tỉnh',
  'crm.cdk.tier': 'Hạng {n}',
  'crm.cdk.active': 'Đang có job',
  'crm.cdk.idleJob': 'Chưa có job kỳ này',
  'crm.cdk.tabAn': 'Phân tích',
  'crm.cdk.tabTask': 'Việc',
  'crm.cdk.tabNoti': 'Thông báo',
  'crm.cdk.unit': 'khách',
  'crm.cdk.byTier': 'Khách theo hạng',
  'crm.cdk.missing': 'Thiếu liên hệ {ct} · thiếu tỉnh {pv} · chưa có TK ngân hàng {bk}',
  'crm.cdk.days': '{n} ngày',
});

addMessages('en', {
  'crm.cdk.new': 'New customers in October',
  'crm.cdk.overdue': 'With overdue receivables',
  'crm.cdk.myWait': 'Awaiting BOD approval for myHANA',
  'crm.cdk.noProv': 'No province',
  'crm.cdk.tier': 'Tier {n}',
  'crm.cdk.active': 'Has active jobs',
  'crm.cdk.idleJob': 'No jobs this period',
  'crm.cdk.tabAn': 'Analytics',
  'crm.cdk.tabTask': 'Tasks',
  'crm.cdk.tabNoti': 'Notifications',
  'crm.cdk.unit': 'customers',
  'crm.cdk.byTier': 'Customers by tier',
  'crm.cdk.missing': 'No contact {ct} · no province {pv} · no bank account {bk}',
  'crm.cdk.days': '{n} days',
});

addMessages('vi', {
  'crm.pd.tab.ov': 'Tổng quan',
  'crm.pd.tab.ct': 'Liên hệ',
  'crm.pd.tab.bank': 'Tài khoản nhận tiền',
  'crm.pd.tab.pay': 'Điều khoản thanh toán',
  'crm.pd.tab.lcc': 'Local charge',
  'crm.pd.tab.portal': 'Tài khoản cổng',
  'crm.pd.tab.wiki': 'Wiki & tệp',
  'crm.pd.tab.refund': 'Refund',
  'crm.pd.tab.hist': 'Lịch sử',
});

addMessages('en', {
  'crm.pd.tab.ov': 'Overview',
  'crm.pd.tab.ct': 'Contacts',
  'crm.pd.tab.bank': 'Payee accounts',
  'crm.pd.tab.pay': 'Payment terms',
  'crm.pd.tab.lcc': 'Local charge',
  'crm.pd.tab.portal': 'Portal accounts',
  'crm.pd.tab.wiki': 'Wiki & files',
  'crm.pd.tab.refund': 'Refund',
  'crm.pd.tab.hist': 'History',
});

addMessages('vi', {
  'crm.cc.noWrite': 'Chưa mở ghi ở bản này',
  'crm.cc.tabClosed': 'Tab này chưa mở ở bản này',
  'crm.cc.tabCus': 'Khách',
  'crm.cc.tabLead': 'Tiềm năng',
  'crm.cc.tabPartner': 'Đối tác',
  'crm.cc.exported': 'Đã xuất {n} khách · CSV gửi vào mail của bạn',
  'crm.cc.count': '{n} khách',
  'crm.cc.notFound': 'Không tìm thấy',
  'crm.cc.noCus': 'Chưa có khách',
  'crm.cc.noMatch': 'Không có khách khớp bộ lọc.',
  'crm.cc.listLabel': 'Danh sách khách',
  'crm.cc.detailClosed': 'Chi tiết khách chưa mở ở bản này',
  'crm.cc.jobs90': '{n} job · 90 ngày',
  'crm.cc.rank': 'Hạng {v}',
});

addMessages('en', {
  'crm.cc.noWrite': 'Editing is not enabled in this version',
  'crm.cc.tabClosed': 'This tab is not enabled in this version',
  'crm.cc.tabCus': 'Customers',
  'crm.cc.tabLead': 'Leads',
  'crm.cc.tabPartner': 'Partners',
  'crm.cc.exported': 'Exported {n} customers · CSV sent to your mailbox',
  'crm.cc.count': '{n} customers',
  'crm.cc.notFound': 'Not found',
  'crm.cc.noCus': 'No customers yet',
  'crm.cc.noMatch': 'No customers match the filters.',
  'crm.cc.listLabel': 'Customer list',
  'crm.cc.detailClosed': 'Customer detail is not enabled in this version',
  'crm.cc.jobs90': '{n} jobs · 90 days',
  'crm.cc.rank': 'Tier {v}',
});

addMessages('vi', {
  'crm.ct.dk.a0': 'Tạo SCSGN202600067 · TUELAMHCMC',
  'crm.ct.dk.a0w': 'DAVID · 21/Oct/2026 09:12',
  'crm.ct.dk.a1': 'Duyệt SCSGN202600066 · BAOANVISION',
  'crm.ct.dk.a1w': 'DAVID · 02/Oct/2026 15:40',
  'crm.ct.dk.a2': 'Nạp lại bộ 5 mẫu',
  'crm.ct.dk.a2w': 'DAVID · 03/Oct/2026 10:00',
  'crm.ct.dk.a3': 'SCSGN202500143 hết hạn · không tự gia hạn vì đã có SCSGN202600056',
  'crm.ct.dk.a3w': 'Hệ thống · 20/Aug/2026 00:05',
  'crm.ct.dk.n0': 'SCSGN202500188 · RUITONGVN-SC còn 20 ngày',
  'crm.ct.dk.n0w': 'Hôm nay 08:00',
  'crm.ct.dk.n1': 'SCSGN202600067 chờ bạn duyệt',
  'crm.ct.dk.n1w': 'Hôm qua 09:12',
  'crm.ct.dk.l0': 'Sắp hết hạn 30 ngày',
  'crm.ct.dk.d0': 'Nhắc Sale gia hạn hoặc ký lại',
  'crm.ct.dk.l1': 'Chờ duyệt',
  'crm.ct.dk.d1': 'Theo ghế [SAL-MGR] rồi [ACC-CA]',
  'crm.ct.dk.l2': 'Khách có job chưa có HĐ',
  'crm.ct.dk.d2': 'Tạo từ hồ sơ khách',
  'crm.ct.dk.l3': 'Trùng MST',
  'crm.ct.dk.d3': 'Rà soát và xoá bản thừa',
  'crm.ct.dk.l4': 'Cảnh báo',
  'crm.ct.dk.l5': 'Hoạt động',
  'crm.ct.dk.l6': 'Thông báo',
  'crm.ct.dk.l7': 'Đóng cột phải',
});

addMessages('en', {
  'crm.ct.dk.a0': 'Create SCSGN202600067 · TUELAMHCMC',
  'crm.ct.dk.a0w': 'DAVID · 21/Oct/2026 09:12',
  'crm.ct.dk.a1': 'Approve SCSGN202600066 · BAOANVISION',
  'crm.ct.dk.a1w': 'DAVID · 02/Oct/2026 15:40',
  'crm.ct.dk.a2': 'Reloaded the 5-template set',
  'crm.ct.dk.a2w': 'DAVID · 03/Oct/2026 10:00',
  'crm.ct.dk.a3': 'SCSGN202500143 expired · not auto-renewed since SCSGN202600056 exists',
  'crm.ct.dk.a3w': 'System · 20/Aug/2026 00:05',
  'crm.ct.dk.n0': 'SCSGN202500188 · RUITONGVN-SC · 20 days left',
  'crm.ct.dk.n0w': 'Today 08:00',
  'crm.ct.dk.n1': 'SCSGN202600067 awaiting your approval',
  'crm.ct.dk.n1w': 'Yesterday 09:12',
  'crm.ct.dk.l0': 'Expiring within 30 days',
  'crm.ct.dk.d0': 'Remind Sale to renew or re-sign',
  'crm.ct.dk.l1': 'Pending approval',
  'crm.ct.dk.d1': 'By seat [SAL-MGR] then [ACC-CA]',
  'crm.ct.dk.l2': 'Customers with jobs but no contract',
  'crm.ct.dk.d2': 'Create from the customer record',
  'crm.ct.dk.l3': 'Duplicate tax ID',
  'crm.ct.dk.d3': 'Review and remove extra copies',
  'crm.ct.dk.l4': 'Alerts',
  'crm.ct.dk.l5': 'Activity',
  'crm.ct.dk.l6': 'Notifications',
  'crm.ct.dk.l7': 'Close right panel',
});
